import React from 'react';
import pb from '../../../lib/pocketbase';
import './Sidebar.css';

const Sidebar = ({ currentTab, onTabChange, pendingAppointmentsCount, agencyData }) => {

    const logoUrl = agencyData && agencyData.logo 
        ? pb.files.getUrl(agencyData, agencyData.logo)
        : null;

    const companyName = agencyData?.company_name || "L'Univers Panel";

    const menuItems = [
        { id: 'dashboard', label: 'Tableau de bord', icon: 'M3 3v18h18M18 9l-5 5-4-4-3 3' }, 
        { id: 'clients', label: 'Clients & Véhicules', icon: 'M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2 M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8' },
        { id: 'requests', label: 'Demandes & Devis', icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6 M16 13H8 M16 17H8 M10 9H8' },
        { id: 'quotes_list', label: 'Devis', icon: 'M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z M14 2v6h6' },
        { id: 'billing', label: 'Facturation', icon: 'M12 2v20 M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6' },
        { id: 'planning', label: 'Planning', icon: 'M19 4h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20a2 2 0 0 0 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V10h14v10z' },
        { id: 'services', label: 'Catalogue', icon: 'M4 6h16M4 12h16M4 18h16' }, 
        { id: 'pricing', label: 'Configuration Prix', icon: 'M20.59 13.41l-7.17 7.17a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z M7 7h.01' }, 
        { id: 'messages', label: 'Message', icon: 'M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z' },
        { id: 'settings', label: 'Paramètres', icon: 'M3 12h18M3 6h18M3 18h18' }
    ];

    return (
        <aside className="admin-sidebar">
            <div className="sidebar-header">
                {logoUrl ? (
                    <img src={logoUrl} alt="Logo" className="sidebar-logo-img" />
                ) : (
                    <span className="sidebar-logo-icon">💠</span>
                )}
                <h3 className="sidebar-title">{companyName}</h3>
            </div>

            <nav className="sidebar-nav">
                <ul className="sidebar-menu">
                    {menuItems.map((item) => (
                        <li key={item.id} className="sidebar-item">
                            <button
                                className={`sidebar-link ${currentTab === item.id ? 'active' : ''}`}
                                onClick={() => onTabChange(item.id)}
                            >
                                <svg className="sidebar-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                                    <path d={item.icon} />
                                </svg>
                                <span>{item.label}</span>
                                {item.id === 'planning' && pendingAppointmentsCount > 0 && (
                                    <span className="sidebar-badge">{pendingAppointmentsCount}</span>
                                )}
                            </button>
                        </li>
                    ))}
                </ul>
            </nav>

            <div className="sidebar-footer">
                <div className="user-profile-mini">
                    <div className="mini-avatar">AD</div>
                    <div className="mini-info">
                        <span className="mini-name">Admin</span>
                        <span className="mini-role">Super Admin</span>
                    </div>
                </div>
            </div>
        </aside>
    );
};

export default Sidebar;
